module.exports = __webpack_public_path__ + "img/cheerfulgive-logo.906e1afa.png";